import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VariedadService } from '../../variedad/service/variedad.service';
import { Observable } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { EspecieService } from '../../especie/service/especie.service';

export interface Descriptor {
  descriptor_id: number;
  descriptor_label: string;
  descriptor_name: string;
  descriptor_categories: any[];
}

@Component({
  selector: 'app-dialog-form-variety',
  templateUrl: './dialog-form-variety.component.html',
  styleUrls: ['./dialog-form-variety.component.css']
})

export class DialogFormVarietyComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA)
  public data: any,
    public dialogRef: MatDialogRef<DialogFormVarietyComponent>,
    private variedadService: VariedadService,
    private especieService: EspecieService) { }

  descriptorObs!: Observable<any>;
  speciesObs!: Observable<any>;
  tuber_yield_per_plant_form = new FormControl("0", [Validators.min(0), Validators.max(9999999)]);
  variety_form = new FormControl("", [Validators.required]);

  descriptor_17!: Descriptor;
  descriptor_19!: Descriptor;
  descriptor_20!: Descriptor;
  descriptor_31!: Descriptor;
  descriptor_32!: Descriptor;
  descriptor_33!: Descriptor;
  descriptor_34!: Descriptor;
  descriptor_36!: Descriptor;
  descriptor_37!: Descriptor;
  descriptor_38!: Descriptor;
  descriptor_39!: Descriptor;
  descriptor_40!: Descriptor;
  descriptor_44!: Descriptor;

  new_variety = {
    species_id: null,
    variety_name: null,
    common_name: null,
    synonyms: null,
    is_original: false,
    descriptors: [
      { descriptor_id: 17, descriptor_category_id: null, string_value: null },
      { descriptor_id: 19, descriptor_category_id: null, string_value: null },
      { descriptor_id: 20, descriptor_category_id: null, string_value: null },
      { descriptor_id: 31, descriptor_category_id: null, string_value: null },
      { descriptor_id: 32, descriptor_category_id: null, string_value: null },
      { descriptor_id: 33, descriptor_category_id: null, string_value: null },
      { descriptor_id: 34, descriptor_category_id: null, string_value: null },
      { descriptor_id: 36, descriptor_category_id: null, string_value: null },
      { descriptor_id: 37, descriptor_category_id: null, string_value: null },
      { descriptor_id: 38, descriptor_category_id: null, string_value: null },
      { descriptor_id: 39, descriptor_category_id: null, string_value: null },
      { descriptor_id: 40, descriptor_category_id: null, string_value: null },
      { descriptor_id: 44, descriptor_category_id: null, string_value: null },
    ],
    comment: null
  };

  ngOnInit(): void {
    this.getSpecies();
    this.getDescriptorList();
  }

  getSpecies() {
    this.speciesObs = this.especieService.getAll();
  }

  getDescriptorList() {
    const is_shared = true;
    this.descriptorObs = this.variedadService.getDescriptor(is_shared);
    this.descriptorObs.subscribe(
      (obj: any) => {
        obj.data.map(
          (obj_item: any) => {
            const _descriptor: Descriptor = {
              descriptor_id: obj_item.descriptor_id,
              descriptor_label: obj_item.descriptor_name,
              descriptor_name: 'descriptor_' + obj_item.descriptor_id,
              descriptor_categories: obj_item.categories,
            };
            switch (obj_item.descriptor_id) {
              case 17:
                this.descriptor_17 = _descriptor;
                break;
              case 19:
                this.descriptor_19 = _descriptor;
                break;
              case 20:
                this.descriptor_20 = _descriptor;
                break;
              case 31:
                this.descriptor_31 = _descriptor;
                break;
              case 32:
                this.descriptor_32 = _descriptor;
                break;
              case 33:
                this.descriptor_33 = _descriptor;
                break;
              case 34:
                this.descriptor_34 = _descriptor;
                break;
              case 36:
                this.descriptor_36 = _descriptor;
                break;
              case 37:
                this.descriptor_37 = _descriptor;
                break;
              case 38:
                this.descriptor_38 = _descriptor;
                break;
              case 39:
                this.descriptor_39 = _descriptor;
                break;
              case 40:
                this.descriptor_40 = _descriptor;
                break;
              case 44:
                this.descriptor_44 = _descriptor;
                break;
              default:
                break;
            }
          }
        );
      }
    );
  }

  getErrorMessage() {
    if (this.variety_form.hasError('required')) {
      return 'You must enter a value';
    }
  }

  fnSelectDescriptor($event: any, descriptor_id: number) {
    const _update_index = this.new_variety.descriptors.findIndex((obj) => obj.descriptor_id == descriptor_id);
    if ($event.value) {
      const _descriptor_updated = {
        descriptor_id: descriptor_id,
        descriptor_category_id: $event.value.descriptor_category_id,
        string_value: $event.value.description
      };
      this.new_variety.descriptors[_update_index] = _descriptor_updated;
    } else {
      const _descriptor_updated = {
        descriptor_id: descriptor_id,
        descriptor_category_id: null,
        string_value: $event.target.value
      };
      this.new_variety.descriptors[_update_index] = _descriptor_updated;
    }
  }

  fnSave() {
    this.variedadService.postVariety(this.new_variety).subscribe(
      ((resp) => {
        if (resp.success) {
          this.dialogRef.close({ variety_name: this.new_variety.variety_name });
        }
      })
    );
  }

}
